// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import React, { useEffect, useState } from 'react';
import moment from 'moment';
import Platform from '../../../components/common/Platform';
import LoadingIcon from '../../../components/LoadingIcon';
import ExamResultDetail from './ExamResultDetail';
import { S } from '../styles';
import { HandsOnCompletionStatusType } from '../../../types/Model';
import { FormattedMessage } from 'react-intl';
import { getHistory } from '../../../apis/member';
import { Link } from 'react-router-dom';
export interface HistoryRow {
  name: string;
  platformId: number;
  levelId: number;
  status: HandsOnCompletionStatusType;
  endTime: Date | null;
  id: number;
}

const HandsOnHistoryTable = (props: any): JSX.Element => {
  const [sortKey, setSortKey] = useState('');
  const [isAscending, setIsAscending] = useState(false);
  const [historyList, setHistoryList] = useState<any>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [examDetail, setExamDetail] = useState<any>([]);
  const [showExamDetail, setShowExamDetail] = useState(false);
  const handsOnType = props.handsOnType;

  const Headers = {
    name: 'B022',
    platformId: 'B023',
    levelId: 'B024',
    status: 'B025',
    endTime: 'B026',
    id: handsOnType === 'exam' ? 'B050' : 'B038',
  }

  const handleSorting = (key: string) => {
    if (key !== 'id') {
      setSortKey(key);
      if (key === sortKey) {
        setIsAscending(!isAscending);
      } else {
        setIsAscending(true);
      }
      if (isAscending) {
        historyList.sort((a: any, b: any) => {
          return a[key].toString().localeCompare(b[key].toString())
        })
      } else {
        historyList.sort((a: any, b: any) => {
          return b[key].toString().localeCompare(a[key].toString())
        })
      }
    }
  }

  const getHistoryData = async () => {
    const result = await getHistory(handsOnType);
    setHistoryList(result.data);
    setIsLoading(false);
  }

  const handleExamResultDetail = (value: any) => {
    setExamDetail(value);
    setShowExamDetail(true);
  }

  useEffect(() => {
    setIsLoading(true);
    getHistoryData()
  }, [handsOnType])

  const renderLoading = () => {
    return (
      <S.LoadingContainer>
        <LoadingIcon size={20} />
      </S.LoadingContainer>
    )
  }

  return (
    <>
      { isLoading ? renderLoading()
        : showExamDetail ? (<ExamResultDetail detail={examDetail} setShowExamDetail={setShowExamDetail}/>)
          : (
            <>
              { historyList.length === 0 ? (
                <S.NoHandsOnHistoryContainer>
                  <S.EmptyHomeIcon />
                  <S.EmptyHomeText><FormattedMessage id="B051" values={{ br: <br/>, handsOnType: handsOnType }} /></S.EmptyHomeText>
                  <S.EmptyHomeLink as={Link} to={`/${handsOnType}s`}><FormattedMessage id="B052" values={{ handsOnType: handsOnType }}/></S.EmptyHomeLink>
                </S.NoHandsOnHistoryContainer>
              ) : (
                <S.HandsOnHistoryTableWrapper>
                  {
                    (Object.keys(Headers) as Array<keyof HistoryRow>).map((key: keyof HistoryRow, index) => (
                      <S.HistoryTableHeading
                        key={index}
                        onClick={() => handleSorting(key)}
                        isCenter={[1, 2, 3, 4, 5].indexOf(index) !== -1}
                      >
                        <S.TableHeadingText><FormattedMessage id={Headers[key]} values={{ br: (<br />) }} />{sortKey === key && <S.TableSortIcon isAscending={isAscending} />}</S.TableHeadingText>
                      </S.HistoryTableHeading>
                    ))
                  }
                  { historyList.map((value: any, index: number) => {
                    return (
                      <React.Fragment key={index}>
                        <S.HistoryTableCell key={index}>{value.name}</S.HistoryTableCell>
                        <S.HistoryTableCell isCenter><Platform id={value.platformId} /></S.HistoryTableCell>
                        <S.HistoryTableCell isCenter><S.LevelMeter levelId={value.levelId} showName={true} /></S.HistoryTableCell>
                        <S.HistoryTableCell isCenter><S.HandsOnCompletionStatusTag type={value.status} /></S.HistoryTableCell>
                        <S.HistoryTableCell isCenter>{value.endTime ? moment(value.endTime).format('YYYY/MM/DD') : '--'}</S.HistoryTableCell>
                        <S.HistoryTableCell isCenter>
                          { handsOnType !== 'exam' ? <S.TableCellLink to={`/${handsOnType}s/${value[handsOnType+'Id']}`}><FormattedMessage id={'B039'} /></S.TableCellLink>
                            :
                            <S.HistoryTableExamLink onClick={() => { handleExamResultDetail(value) }}><S.VisibleIcon /></S.HistoryTableExamLink>
                          }
                        </S.HistoryTableCell>
                      </React.Fragment>
                    )
                  })}
                </S.HandsOnHistoryTableWrapper>
              ) }
            </>
          ) }
    </>
  );
};

export { HandsOnHistoryTable as default };
